module.exports = __webpack_public_path__ + "579d93e2ee8e888df7b4c848981a29b3.png";